import styled from 'styled-components';
import ListItemCompoment from '@prisjakt/ui-list-item';
import StoreLogoComponent from '@prisjakt/ui-store-logo';

// eslint-disable-next-line import/prefer-default-export
export const ListItem = styled(ListItemCompoment)({
  '&&': {
    img: {
      marginRight: '10px',
    },
  },
});

export const StoreLogo = styled(StoreLogoComponent)`
  height: 24px;
  img {
    height: 16px;
  }
`;
